<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For Karen Lahey, because until I met her I never made the connection that “people” write books. (Where I thought they came from, I have no idea.) Essentially, Karen’s responsible for my being a writer so if you’ve enjoyed any of my books, you should thank her. Thank you, Karen.</p>
<p class="center"><em>I’d like to thank Blanche McDermaid and the cast and crew of A&amp;E’s </em>Nero Wolfe Mysteries<em>, who graciously allowed me to hang about the set. I’d especially like to thank Matt and PJ, the PAs, who were more than patient with two solid days of stupid questions. Anything I got right, I owe to them. Mistakes are all my own.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?4de3c7a0